import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateSecurityCredentials} from 'modules/store/securityCredentials';
import {TIMEOUT_STORE} from 'util/constants';

const
    transformEntitiesFn = credential => {

        if (typeof credential !== 'object') {
            throw new Error('transformEntitiesFn needs an object to transform');
        }

        return {
            id:     credential.id,
            alias:  credential.alias,
            vendor: {
                selected: vendorCodes.gcloud,
                values:   {
                    service:             credential.service.id,
                    slug:                credential.service.slug,
                    account:             credential.account.id,
                    accountName:         credential.account.name,
                    credentialsFilename: credential.service_account_filename
                }
            }
        };
    },
    mapFields = {
        account:             'account',
        service:             'service',
        credentialsFilename: 'service_account_filename'
    },
    mapParametersToSave = {
        credentialsFile: 'service_account_key',
        account:         'account',
        service:         'service'
    },
    transformEntitiesToSaveFn = credential => Object.keys(credential.vendor)
        .reduce((ret, key) => ({
            ...ret,
            [mapParametersToSave[key]]: credential.vendor[key]
        }), {
            alias:           credential.alias,
            account:         credential.account,
            service:         credential.service,
            credentialsFile: credential.service_account_filename
        });

const exports = storeModuleFactory({
    name:             'googleCredentials',
    endpoint:         endpoints.securityCredentials.google.endpoint,
    instanceEndpoint: endpoints.securityCredentials.google.instanceEndpoint,
    callbackActions:  [{
        method: 'create',
        action: invalidateSecurityCredentials
    },{
        method: 'update',
        action: invalidateSecurityCredentials
    },{
        method: 'delete',
        action: invalidateSecurityCredentials
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/googleCredentials.js